{
  "appName": "Currency - Exchange",
  "brand": "Musafer",
  "notFound": "Page not found",
  "backHome": "Back to home",
  "home": {
    "title": "Currency exchange systems",
    "branch": "Branch",
    "exchange": "Currency exchange system",
    "exchangeVip": "Currency exchange system (VIP)",
    "exchangeHint": "Exchange at ordinary prices",
    "exchangeVipHint": "Exchange at VIP prices",
    "balance": "Box balance",
    "balanceHint": "Your box balance in each currency",
    "noBoxTitle": "No box is linked to your account",
    "noBoxDescription": "You cannot exchange until a box is assigned to you in this branch. Contact your supervisor.",
    "loadFailed": "The exchange data could not be loaded.",
    "retry": "Refresh",
    "cashEntries": "Cash receipts and payments",
    "cashEntriesHint": "Record cash in and out of your box"
  },
  "box": {
    "pickTitle": "Choose the box",
    "pickDescription": "You are linked to more than one box. Choose the box you are working on now.",
    "change": "Change the box",
    "current": "Box",
    "loading": "Loading the boxes",
    "unavailable": "The box is no longer available, choose another box."
  },
  "balance": {
    "title": "Box balance",
    "description": "Your box balance in each currency.",
    "refresh": "Refresh",
    "loading": "Loading the balance",
    "emptyTitle": "The box holds no balance",
    "emptyDescription": "The balance appears here after the box is fed or an exchange is posted."
  },
  "form": {
    "convert": "Convert currency",
    "from": "From",
    "to": "To",
    "fromCurrency": "Currency received from the customer",
    "toCurrency": "Currency paid to the customer",
    "buyPrice": "Buy Price",
    "sellPrice": "Sell Price",
    "amount": "Amount to convert",
    "convertedAmount": "Converted amount",
    "finalResult": "Final result",
    "lastPriceChange": "Last currency price change",
    "calculating": "Calculating...",
    "resultPlaceholder": "Choose both currencies and enter the amount to see the result.",
    "insufficientBalance": "The box does not hold enough of this currency.",
    "swap": "Swap currencies",
    "customer": "Customer",
    "phone": "Customer phone number",
    "name": "Customer name (optional)",
    "lookingUp": "Looking up the customer...",
    "customerFound": "Customer found: {{name}}",
    "customerNotFound": "No matching customer. One will be registered when the exchange is confirmed.",
    "photo": "Add a photo (optional)",
    "photoHint": "JPEG, PNG or WebP, up to 5 MB.",
    "takePhoto": "Take photo",
    "chooseFromGallery": "Choose from gallery",
    "removePhoto": "Remove photo",
    "photoPreview": "Customer photo",
    "photoTooLarge": "The photo is larger than 5 MB.",
    "photoWrongType": "Choose a JPEG, PNG or WebP image.",
    "note": "Add a note (optional)",
    "continue": "Continue",
    "amountRequired": "Enter the amount.",
    "amountTooManyDecimals": "At most five decimal places are allowed.",
    "sameCurrency": "Choose a different currency.",
    "currencyRequired": "Choose the currency.",
    "requiredNote": "Required fields are marked with an asterisk",
    "noCurrencies": "No currencies are available for exchange."
  },
  "summary": {
    "title": "Transaction summary",
    "convert": "Convert currency",
    "from": "From",
    "to": "To",
    "finalAmount": "Final amount",
    "customerName": "Customer Name",
    "customerPhone": "Customer phone number",
    "photo": "Photo",
    "notes": "Notes",
    "none": "—",
    "saveAndPrint": "Save and print",
    "saveWithoutPrint": "Save without printing",
    "back": "Back",
    "cancel": "Cancel",
    "saving": "Saving...",
    "uploadFailed": "Could not upload the photo. Try again or remove the photo.",
    "saveFailed": "The exchange could not be executed."
  },
  "signature": {
    "title": "Customer signature (optional)",
    "notPresent": "Customer not present",
    "notPresentHint": "Nothing is sent to the tablet; the transaction is saved without the customer's data and signature.",
    "tablet": "Tablet",
    "chooseTablet": "Choose a tablet",
    "noTablets": "No active tablets in this branch",
    "send": "Send to tablet",
    "sending": "Sending...",
    "resend": "Resend to tablet",
    "cancelSend": "Cancel sending",
    "waiting": "Awaiting the customer's signature",
    "online": "Online",
    "offline": "Offline",
    "busy": "The tablet is busy",
    "busyWith": "The tablet is busy: {{system}}",
    "signed": "Signed",
    "image": "Signature",
    "imageFailed": "The signature could not be shown.",
    "saveFailed": "Could not save the signature. The exchange was not saved.",
    "saveWithout": "Save without the signature",
    "sendAgain": "You can send it to the tablet again for the customer to sign.",
    "expired": "The request ended before the customer finished. Send it to the customer again.",
    "cancelled": "This request has ended and is no longer available."
  },
  "done": {
    "successTitle": "The transaction was completed successfully",
    "reference": "Reference",
    "home": "Home",
    "receiptTitle": "Receipt",
    "print": "Print",
    "newExchange": "New transaction"
  },
  "receipt": {
    "date": "Date",
    "time": "Time",
    "received": "Amount received",
    "paid": "Amount paid",
    "rate": "Exchange price",
    "customerName": "Customer name",
    "customerPhone": "Customer phone",
    "thanks": "Thank you for your visit"
  },
  "pwa": {
    "install": "Install the app"
  },
  "cashEntries": {
    "title": "Cash receipts and payments",
    "loading": "Loading cash receipts and payments",
    "receipt": "Receipt",
    "payment": "Payment",
    "recordReceipt": "Record a receipt",
    "recordPayment": "Record a payment",
    "receiptHint": "Cash coming into your box outside an exchange, such as cash from management.",
    "paymentHint": "Cash leaving your box outside an exchange, such as an administrative expense.",
    "type": "Type",
    "allTypes": "All types",
    "number": "Number",
    "box": "Box",
    "cashier": "Cashier",
    "date": "Date",
    "currency": "Currency",
    "amount": "Amount",
    "description": "Description",
    "chooseCurrency": "Choose the currency",
    "enterAmount": "Enter the amount",
    "amountPositive": "The amount must be greater than zero",
    "tooManyDecimals": "The amount accepts at most five decimal places",
    "insufficient": "Insufficient box balance",
    "enterDescription": "Enter the description",
    "available": "Available balance:",
    "empty": "No cash receipts or payments yet",
    "noResults": "No movements of this type",
    "view": "View movement {{number}}",
    "detailsTitle": "Movement details",
    "page": "Page {{page}} of {{total}}",
    "previous": "Previous",
    "next": "Next",
    "cancel": "Cancel",
    "summaryTitle": "Transaction summary",
    "save": "Save",
    "savedNumber": "Movement number {{number}}",
    "backToList": "Back to the list"
  }
}
